export default __webpack_public_path__ + "static/media/TITULO_DISCO_01.b9f62889.png";